export class RewardedRunState {
  continueUsed = false;
  doubleGoldClaimed = false;

  reset(): void {
    this.continueUsed = false;
    this.doubleGoldClaimed = false;
  }

  canOfferContinue(): boolean {
    return !this.continueUsed;
  }

  useContinue(): boolean {
    if (this.continueUsed) return false;
    this.continueUsed = true;
    return true;
  }

  canOfferDoubleGold(): boolean {
    return !this.doubleGoldClaimed;
  }

  claimDoubleGold(): boolean {
    if (this.doubleGoldClaimed) return false;
    this.doubleGoldClaimed = true;
    return true;
  }
}
